import type {
  JsonSchemaObject,
  ToolParameterField,
  ToolParameterType,
} from '@/features/tools/types'

export const EMPTY_ARGS_SCHEMA: JsonSchemaObject = {
  type: 'object',
  properties: {},
  required: [],
}

const PYTHON_IDENTIFIER_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/

export function isValidToolParameterName(name: string): boolean {
  return PYTHON_IDENTIFIER_PATTERN.test(name) && !name.startsWith('model_')
}

export function parametersToArgsSchema(
  fields: ToolParameterField[]
): JsonSchemaObject {
  const properties: JsonSchemaObject['properties'] = {}
  const required: string[] = []
  for (const field of fields) {
    const name = field.name.trim()
    if (!name) continue
    properties[name] = {
      type: field.type,
      ...(field.description.trim()
        ? { description: field.description.trim() }
        : {}),
    }
    if (field.required) required.push(name)
  }
  return { type: 'object', properties, required }
}

export function argsSchemaToParameters(
  schema: JsonSchemaObject | null | undefined
): ToolParameterField[] {
  if (!schema?.properties) return []
  const required = new Set(schema.required ?? [])
  return Object.entries(schema.properties).map(([name, property]) => ({
    name,
    type: isToolParameterType(property.type) ? property.type : 'string',
    description: property.description ?? '',
    required: required.has(name),
  }))
}

function isToolParameterType(value: string): value is ToolParameterType {
  return ['string', 'number', 'integer', 'boolean', 'array', 'object'].includes(
    value
  )
}
